import apiHandler from "../core/apiHandler";

const cashRegisterApi = apiHandler('cash/registers');

export default cashRegisterApi;